import React, { useEffect, useMemo, useState } from "react";

function UcStatIcon({ iconText }) {
  return (
    <div className="ac-uc-stat-icon">
      <span>{iconText}</span>
    </div>
  );
}

export default function StatCard({ title, value, hint, iconText, onClick }) {
  const numeric = typeof value === "number" || (!isNaN(Number(value)) && value !== "");
  const target = numeric ? Number(value) : 0;
  const [display, setDisplay] = useState(target);

  useEffect(() => {
    if (!numeric) return;

    const start = display;
    const end = target;
    const duration = 240;
    const startTime = performance.now();
    let raf = 0;

    const tick = (t) => {
      const p = Math.min(1, (t - startTime) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(start + (end - start) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, numeric]);

  const finalValue = useMemo(() => {
    if (!numeric) return value;
    return display.toLocaleString("de-AT");
  }, [display, numeric, value]);

  return (
    <button
      type="button"
      onClick={onClick}
      className="ac-soft-panel ac-uc-statcard"
    >
      <div className="ac-uc-statcard-top">
        <div className="ac-uc-statcard-copy">
          <UcStatIcon iconText={iconText} />

          <div>
            <div className="ac-uc-statcard-title">{title}</div>
            <div className="ac-uc-statcard-hint">{hint}</div>
          </div>
        </div>
      </div>

      <div className="ac-uc-statcard-value">{finalValue}</div>
    </button>
  );
}